import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

interface DeleteSubmissionDialogProps {
  isOpen: boolean;
  isDeleting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const DeleteSubmissionDialog = ({
  isOpen,
  isDeleting,
  onClose,
  onConfirm,
}: DeleteSubmissionDialogProps) => {
  return (
    <Dialog
      open={isOpen}
      onClose={() => {
        if (!isDeleting) {
          onClose();
        }
      }}
    >
      <DialogTitle>Delete Submission</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete this submission? It will be archived
          and removed from search results. This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isDeleting}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={isDeleting}
          startIcon={isDeleting ? <CircularProgress size={16} /> : undefined}
        >
          {isDeleting ? "Deleting..." : "Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
